export const MIN_SWIPE_DISTANCE = 50;
export const PERCENTAGE = 100;
